import React from 'react';

import { HomeCardFront } from '../home-card-front';

export interface HomeCustomerCardFrontProps
  extends Readonly<{
    onButtonPress: () => void;
    style?: React.CSSProperties;
  }> {}

export const HomeCustomerCardFront = React.memo<HomeCustomerCardFrontProps>((props) => {
  const { onButtonPress, style } = props;

  return (
    <HomeCardFront
      icon={'avatar'}
      iconColor={'quaternary'}
      title={'Create future-proof customer experience'}
      onButtonPress={onButtonPress}
      style={style}
    />
  );
});
